module.exports = new __parcel__URL__("visit_mission_btn.04b7ca91.png").toString();